import React from 'react';
export function Footer() {
  return <footer className="w-full py-6 md:py-8 lg:py-12 px-6 md:px-8 lg:px-20 bg-brand-navy border-t border-white/10 text-center" data-id="element-55">
      <div className="text-[16px] text-white font-semibold mb-3" data-id="element-56">
        TUBO™ Water Wellness
      </div>

      <div className="flex flex-wrap justify-center gap-6 text-[13px] text-[#A0A0A0] mb-5" data-id="element-57">
        <span data-id="element-58">✓ Australian-Owned</span>
        <span data-id="element-59">✓ 60-Day Guarantee</span>
        <span data-id="element-60">✓ Free Support</span>
        <span data-id="element-61">✓ Fast Shipping</span>
      </div>

      <div className="text-[12px] text-brand-gray mb-4 flex flex-wrap justify-center gap-2" data-id="element-62">
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-63">
          Privacy Policy
        </a>
        <span data-id="element-64">|</span>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-65">
          Terms & Conditions
        </a>
        <span data-id="element-66">|</span>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-67">
          Shipping Info
        </a>
        <span data-id="element-68">|</span>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-69">
          Contact Us
        </a>
      </div>

      <div className="text-[12px] text-brand-gray" data-id="element-70">
        © 2026 TUBO™ Water Wellness. All rights reserved. ABN: [INSERT]. ACCC
        Compliant.
      </div>
    </footer>;
}